import React, {Component} from 'react';
import {HashRouter as Router, Route, Switch} from 'react-router-dom';
import {Home} from './Home';
import {Work} from './Work';
import {Resume} from './Resume';
import {PaymentsProducts} from './PaymentsProducts';
import {CreativeOperations} from './CreativeOperations';
import {InvitationHomes} from './InvitationHomes';
import {Sanmina} from './Sanmina';
import {Layout} from './components/Layout';
import {NavigationBar} from './components/NavigationBar';
import {Jumbotron} from './components/Jumbotron';
import './App.css';

 
class App extends Component {
	render() {
		return(
		<React.Fragment>
			<Router>
			<NavigationBar />
				 <footer class="footer">
					<div class="container">
        				<span> &copy;{new Date().getFullYear()} Jay Topiwala | Powered with React</span>
					</div>
    			</footer>
					<Switch>
						<Route exact path="/" component={Home} />
						<Route path='/work/' component = {Work} />
						<Route path ='/resume/' component={Resume} />
						<Route path ="/paymentsproducts" component={PaymentsProducts} />
						<Route path ="/creativeoperations" component={CreativeOperations} />
						<Route path ="/sanmina" component={Sanmina} />
						<Route path ="/invitationhomes" component ={InvitationHomes} />
					
					</Switch>
				</Router>
		</React.Fragment>
		);
	}
}

export default App;
